// @flow
import React, { Component, Fragment } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'
import type { Media } from '../../types'
import { translateFunc, translations } from '../../../shared/localize'
import { linkColor } from '../../controls/colors'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
`
const Error: StyledComponent<Object, any, any> = styled.div`
  color: red;
  font-size: 12px;
`
const Link: StyledComponent<Object, any, any> = styled.div`
  font-size: ${({ fontSize }: Object) => `${fontSize || 12}`}px;
  color: ${({ disabled }: Object) => (disabled ? 'gray' : linkColor)};
  text-decoration: underline;
  cursor: pointer;
`

type Props = {|
  media: ?(Media & { id?: ?number }),
  isLoading: boolean,
  errors: Array<string>,
  title?: string,
  titleFontSize?: number,
  onOpenFileDialog: Function
|}

const t = translateFunc(translations.single_media_loader)

export default class TextPreview extends Component<Props> {
  render() {
    const { media, onOpenFileDialog, title, titleFontSize, isLoading, errors } = this.props

    return (
      <Wrapper>
        {media && _.isEmpty(errors) ? (
          <Fragment>
            <Link
              disabled={isLoading}
              fontSize={titleFontSize}
              onClick={() => onOpenFileDialog && onOpenFileDialog()}
            >
              {isLoading ? t('loading') : title || t('choose_another')}
            </Link>
          </Fragment>
        ) : (
          <Fragment>
            <Link
              disabled={isLoading}
              fontSize={titleFontSize}
              onClick={() => onOpenFileDialog && onOpenFileDialog()}
            >
              {isLoading ? t('loading') : title || t('choose')}
            </Link>
            <div className="t-MediaErrorText">
              {!_.isEmpty(errors) &&
                _.map(errors, (error, index: number) => <Error key={index}>{error}</Error>)}
            </div>
          </Fragment>
        )}
      </Wrapper>
    )
  }
}
